import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Col, Form, Label, Row } from "reactstrap";
import {
  BlockDes,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  ReactDataTable,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useDataFetch } from "../../../hooks/useDataFetch";

const ConfigurationPage = () => {
  const [item, setItem] = useState();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onFormSubmit = (e) => {
    updateConfig({
      id: item.id,
      info: e.info,
      dontation_url: e.dontation_url,
      donation_text: e.donation_text,
    });
  };

  const formClass = classNames({
    "form-validate": true,
  });

  const { getData, patchData, invalidateQuery } = useDataFetch();

  const { data, isLoading, refetch } = getData(
    ["configurations"],
    "/panel/configurations",
    { enabled: true }
  );

  const { mutate: updateConfig, isLoading: isPostLoading } = patchData(
    "/panel/configurations",
    {},
    {},
    {
      onSuccess: (data) => {
        reset();
        invalidateQuery(["configurations"]);
      },
    }
  );

  useEffect(() => {
    if(data && data?.length > 0){
        setItem(data[0]);
        setValue("info", data[0]["info"]);
        setValue("dontation_url", data[0]["dontation_url"]);
        setValue("donation_text", data[0]["donation_text"]);
    }
  }, [data]);

  return (
    <React.Fragment>
      <Head title="Configuraciones"></Head>
      <Content>
        <Card className="">
          <div className="">
            <div className={` p-4`}>
              <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
                <Row className="g-gs">
                  <Col md="12">
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        Información para la pagina web
                      </BlockTitle>
                      <BlockDes></BlockDes>
                    </BlockHeadContent>
                    <Row>
                      <Col md="12" lg="12">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Url para las donaciones
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="text"
                              id="fv-full-name"
                              {...register("dontation_url", { required: true })}
                              className="form-control"
                            />
                            {errors.dontation_url && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="12" lg="12">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Texto para la pagina de donaciones
                          </Label>
                          <div className="form-control-wrap">
                            <textarea
                              type="text"
                              id="fv-full-name"
                              {...register("donation_text", { required: true })}
                              className="form-control"
                            ></textarea>
                            {errors.donation_text && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="12" lg="12">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Texto para la pagina principal
                          </Label>
                          <div className="form-control-wrap">
                            <textarea
                              type="text"
                              id="fv-full-name"
                              {...register("info", { required: true })}
                              className="form-control"
                            ></textarea>
                            {errors.info && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col md="12">
                    <div className="form-group">
                      <Button color="primary" size="lg">
                        Actualizar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default ConfigurationPage;
